module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "loading": _vm.loading,
            "rounded": "",
            "text": "",
            "icon": _vm.small
          },
          on: {
            "click": function($event) {
              return _vm.rechnungVersenden(_vm.rechnung)
            }
          }
        }, 'v-btn', attrs, false), on), [(_vm.icon) ? _c('v-icon', [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('span', [_vm._v(_vm._s(_vm.text))]) : _vm._e()], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Rechnung per Mail senden")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d43206"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/rechnungSenden.vue
// module id = 767
// module chunks = 15